window.RGDSliderDots = window.RGDSliderDots || {
  init(root = document) {
    const dotsInstances = root.querySelectorAll("[data-slider-dots-root]");

    dotsInstances.forEach((dotsRoot) => {
      this.initInstance(dotsRoot);
    });
  },

  initInstance(dotsRoot) {
    if (!dotsRoot || dotsRoot.dataset.rgdSliderDotsInitialized === "true") return;

    const section = dotsRoot.closest(".shopify-section") || document;

    const trackSelector = dotsRoot.dataset.trackSelector || "";
    const slideSelector = dotsRoot.dataset.slideSelector || "";
    const perViewMobile = Math.max(1, Math.round(parseFloat(dotsRoot.dataset.perViewMobile || "1")));
    const perViewTablet = Math.max(1, Math.round(parseFloat(dotsRoot.dataset.perViewTablet || "2")));
    const perViewDesktop = Math.max(1, Math.round(parseFloat(dotsRoot.dataset.perViewDesktop || "3")));

    if (!trackSelector || !slideSelector) return;

    const dotsWrap = dotsRoot.querySelector("[data-slider-dots]");
    const track = section.querySelector(trackSelector);

    if (!dotsWrap || !track) return;

    const getSlides = () => Array.from(track.querySelectorAll(slideSelector));

    const getPerView = () => {
      if (window.innerWidth <= 749) return perViewMobile;
      if (window.innerWidth <= 989) return perViewTablet;
      return perViewDesktop;
    };

    const getGap = () => {
      const styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap || 0);
    };

    const getStep = () => {
      const slides = getSlides();
      if (!slides.length) return 0;
      return slides[0].getBoundingClientRect().width + getGap();
    };

    const getPages = () => {
      const slides = getSlides();
      const perView = getPerView();
      return Math.max(1, Math.ceil(slides.length / perView));
    };

    const getPageOffset = (pageIndex) => {
      const perView = getPerView();
      const step = getStep();
      return step * perView * pageIndex;
    };

    const getActivePage = () => {
      const perView = getPerView();
      const step = getStep();
      const pages = getPages();

      if (!step) return 0;

      const rawIndex = Math.round(track.scrollLeft / (step * perView));
      return Math.max(0, Math.min(rawIndex, pages - 1));
    };

    const buildDots = () => {
      const pages = getPages();
      dotsWrap.innerHTML = "";

      if (pages <= 1) {
        dotsRoot.hidden = true;
        return;
      }

      dotsRoot.hidden = false;

      for (let i = 0; i < pages; i++) {
        const dot = document.createElement("button");
        dot.type = "button";
        dot.className = "slider-dots-controls__dot";
        dot.setAttribute("aria-label", `Ir para página ${i + 1}`);
        dot.addEventListener("click", () => {
          track.scrollTo({
            left: getPageOffset(i),
            behavior: "smooth"
          });
        });
        dotsWrap.appendChild(dot);
      }
    };

    const updateDots = () => {
      const dots = Array.from(dotsWrap.children);
      if (!dots.length) return;

      const activePage = getActivePage();

      dots.forEach((dot, i) => {
        dot.classList.toggle("is-active", i === activePage);
      });
    };

    track.addEventListener("scroll", updateDots, { passive: true });

    dotsRoot._rgdSliderDotsBuild = buildDots;
    dotsRoot._rgdSliderDotsUpdate = updateDots;

    dotsRoot.dataset.rgdSliderDotsInitialized = "true";

    setTimeout(() => {
      buildDots();
      updateDots();
    }, 80);
  },

  refresh(root = document) {
    const dotsInstances = root.querySelectorAll("[data-slider-dots-root]");

    dotsInstances.forEach((dotsRoot) => {
      if (typeof dotsRoot._rgdSliderDotsBuild === "function") {
        dotsRoot._rgdSliderDotsBuild();
      }
      if (typeof dotsRoot._rgdSliderDotsUpdate === "function") {
        dotsRoot._rgdSliderDotsUpdate();
      }
    });
  }
};

document.addEventListener("DOMContentLoaded", () => {
  window.RGDSliderDots.init(document);
});

document.addEventListener("shopify:section:load", (event) => {
  window.RGDSliderDots.init(event.target);
  window.RGDSliderDots.refresh(event.target);
});

let rgdSliderDotsResizeTimer;
window.addEventListener("resize", () => {
  clearTimeout(rgdSliderDotsResizeTimer);
  rgdSliderDotsResizeTimer = setTimeout(() => {
    window.RGDSliderDots.refresh(document);
  }, 120);
});